import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DefaultService} from '../../../gen/swagger-api/api/default.service';
import {AlertService} from '../../shared/services/alert.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {SubscriptionService} from '../../shared/services/subscription.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs/Subject';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {LastSearches} from '../../shared/model/last-searches';
import {LastSearch} from '../../shared/model/last-search';
import {ColumnSortedEvent} from '../../shared/services/column-sort.service';
import {CARDGROUPINFO} from '../../../gen/swagger-api/model/cARDGROUPINFO';
import {Subscription} from 'rxjs/Subscription';
// import {MNOSUBSCRIPTIONINFO} from '../../../gen/swagger-api/model/mNOSUBSCRIPTIONINFO';
import {SubscriptionPoolMnoAuditComponent} from '../modals/subscription-pool-mno-audit/subscription-pool-mno-audit.component';
import {DefaultServiceGetSubscriptionPools} from '../../shared/services/workaround/default-service-get-subscription-pools.service';
import {ErrorHandlingService} from '../../shared/services/error-handling-service';
import {POOLINFO, SMDPPROFILE} from '../../../gen/swagger-api';
import {UserType} from '../../shared/model/user-type';
import {AuthService} from '../../shared/services/auth/auth.service';
import {SelectionOperationModalComponent} from '../modals/selection-operation-modal/selection-operation-modal.component';
import {ScDeleteCardsModalComponent} from '../modals/sc-delete-cards-modal/sc-delete-cards-modal.component';
import {MoveProfilesModalComponent} from '../modals/move-profiles/move-profiles-modal.component';

@Component({
  selector: 'app-subscription-pools-page',
  templateUrl: './subscription-pools-page.component.html',
  styleUrls: ['./subscription-pools-page.component.css']
})
export class SubscriptionPoolsPageComponent implements OnInit, OnDestroy {

  static readonly LIMIT: number = 50;
  public subscriptionPools: Array<POOLINFO> = [];
  operationName: string;
  bsModalRef: BsModalRef;
  multipleOwnersSaved = true;
  public searchText: string;
  public searchProperty: string;
  offset = 0;
  subscriptionsOffset = 0;
  public nameOfSearch: string;
  searchString$: Subject<string> = new Subject<string>();
  public onlyActiveCards = true;
  public selectedSubscriptionIds: Array<number> = [];
  public selectedPoolSubscriptionIds: Array<string> = [];
  public selectedCardGroupIds: Array<String> = [];
  public selectedPoolIds: Array<String> = [];
  public editingPoolIds: Array<String> = [];
  public selectedStatus: Array<String> = [];
  public selectedPoolOwnerIds: Array<string> = [];
  public unselectedPoolOwnersIds: Array<string> = [];
  public showOperationButton = false;
  fails = [];
  public userType: UserType;
  public userTypeEnum = UserType; // to use enum in ngIf
  operationsDisabled: boolean = this.selectedSubscriptionIds.length === 0;
  sortCriteria: ColumnSortedEvent;
  username: string;
  cardGroupsMap: any;
  cardGroups: Array<CARDGROUPINFO>;
  timerSubscription: Subscription;
  pools: Array<POOLINFO>;
  permissions: Array<string>;

  // last Searches properties
  lastSearches: Array<String> = [];
  searchCtrl = new FormControl();
  searchForm = new FormGroup({
    searchCtrl: this.searchCtrl
  });

  poolDetails: POOLINFO;
  mnoSubscriptions: Array<SMDPPROFILE>;

  newSubscriptionForm: FormGroup;
  newMode = false;
  editMode = false;
  viewMode = false;

  tabView = 'tab1';
  activeTab = 'home';

  _mnoSubscriptionFilterCriteria: string;
  filteredMnoSubscriptions: Array<SMDPPROFILE> = [];

  _mnoOwnersFilterCriteria: string;
  private helpService: DefaultServiceGetSubscriptionPools;

  @ViewChild('checkAllSubscriptions') checkAllSubscriptions;

  /**----------------------------------------------------------------------------
   * constructor
   *-----------------------------------------------------------------------------*/
  constructor(private subscriptionService: SubscriptionService,
              private modalService: BsModalService,
              private defaultService: DefaultService,
              private alertService: AlertService,
              private fb: FormBuilder,
              helpService: DefaultServiceGetSubscriptionPools,
              private authenticationService: AuthService,
              private errorHandlingService: ErrorHandlingService) {
    this.helpService = helpService;
    this.searchString$.debounceTime(500)
      .distinctUntilChanged()
      .do(searchText => this.searchText = searchText)
      .do(searchText => this.saveSearchText(searchText, this.searchProperty))
      .switchMap(searchText => {
        this.subscriptionPools = [];
        this.offset = 0;
        const filterParams = {
          selectedCardGroupIds: this.selectedCardGroupIds,
          selectedPoolIds: this.selectedPoolIds,
          selectedStatus: this.selectedStatus,
          onlyActiveCards: this.onlyActiveCards
        };

        return this.subscriptionService.poolSubscriptions(this.offset, SubscriptionPoolsPageComponent.LIMIT, this.sortCriteria,
          searchText, this.searchProperty, filterParams);

      })
      .subscribe(subscription => {
          this.subscriptionPools = this.subscriptionPools.concat(subscription);
        },
        (error) => {
          this.errorHandlingService.errorHandling(error);
        });
  }

  /**----------------------------------------------------------------------------
   * ngOnInit
   *-----------------------------------------------------------------------------*/
  ngOnInit() {
    // this.loadSubscriptionPools(SubscriptionPoolsPageComponent.LIMIT, 0, undefined, undefined, false);
    this.selectedSubscriptionIds = [];
    this.username = sessionStorage.getItem('username');
    this.timerSubscription = Observable.timer(environment.mainPageRefreshInterval).first().subscribe(() => this.refreshCallback());
    this.userType = UserType[sessionStorage.getItem('userType')];
    this.setSearchProperty('poolName');
    this.newSubscriptionForm = this.fb.group({
      poolId: [''],
      poolName: ['', [Validators.required]],
      mnoId: ['', [Validators.required]],
      country: ['', [Validators.required]]
    });
  }

  /**----------------------------------------------------------------------------
   * ngOnDestroy
   *-----------------------------------------------------------------------------*/
  public ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }


  /**----------------------------------------------------------------------------
   * onSorted
   *-----------------------------------------------------------------------------*/
  onSorted($event) {
    this.subscriptionPools = []; // reset subscriptionslist
    this.offset = 0; // reset offset
    this.sortCriteria = $event;
    this.loadSubscriptionPools(SubscriptionPoolsPageComponent.LIMIT, this.offset, this.searchText, this.searchProperty, false);
  }


  /**----------------------------------------------------------------------------
   * loadSubscriptionPools
   *-----------------------------------------------------------------------------*/
  public loadSubscriptionPools(limit: number = SubscriptionPoolsPageComponent.LIMIT, offset = 0, searchString?: string,
                           searchProperty?: string, concat: boolean = true): void {
    const filterParams = {
      selectedCardGroupIds: this.selectedCardGroupIds,
      selectedPoolIds: this.selectedPoolIds,
      selectedStatus: this.selectedStatus,
      onlyActiveCards: this.onlyActiveCards
    };

    this.subscriptionService.poolSubscriptions(offset, limit, this.sortCriteria, searchString, searchProperty, filterParams).subscribe(
      subscription => {
        if (concat) {
          this.subscriptionPools = this.subscriptionPools.concat(subscription);
        } else {
          this.subscriptionPools = subscription;
        }

      },
      (error) => {
          if (!error.status || error.status != 404) {
              this.errorHandlingService.errorHandling(error);
          }
      }
    );
  }


  /**----------------------------------------------------------------------------
   * checkAll
   *-----------------------------------------------------------------------------*/
  public checkAll(ev) {
    this.subscriptionPools.forEach(x => {
      if (ev.target.checked) {
        this.selectedSubscriptionIds.push(x.poolId);
      } else {
        this.selectedSubscriptionIds = [];
      }
    });
    this.operationsDisabled = this.selectedSubscriptionIds.length === 0;
  }


  /**----------------------------------------------------------------------------
   * onToggleSelectedElement
   *-----------------------------------------------------------------------------*/
  public onToggleSelectedElement(ev) {
    const id = ev.target.value;
    if (this.selectedSubscriptionIds.includes(id)) {
      const index = this.selectedSubscriptionIds.findIndex(d => d === id); // find index in your array
      this.selectedSubscriptionIds.splice(index, 1); // remove element from array
    } else {
      this.selectedSubscriptionIds.push(id);
    }
    this.operationsDisabled = this.selectedSubscriptionIds.length === 0;
  }


  /**----------------------------------------------------------------------------
   * checkAllPoolSubscriptions
   *-----------------------------------------------------------------------------*/
  public checkAllPoolSubscriptions(ev) {
    this.mnoSubscriptions.forEach(x => {
      if (ev.target.checked) {
        this.selectedPoolSubscriptionIds.push(x.iccid);
      } else {
        this.selectedPoolSubscriptionIds = [];
      }
    });
  }

  /**----------------------------------------------------------------------------
   * onToggleSelectedSubscriptionElement
   *-----------------------------------------------------------------------------*/
  public onToggleSelectedSubscriptionElement(ev) {
    const veis = ev.target.value;
    if (this.selectedPoolSubscriptionIds.includes(veis)) {
      const index = this.selectedPoolSubscriptionIds.findIndex(d => d === veis); // find index in your array
      this.selectedPoolSubscriptionIds.splice(index, 1); // remove element from array
    } else {
      this.selectedPoolSubscriptionIds.push(veis);
    }
  }


  /**----------------------------------------------------------------------------
   * logout
   *-----------------------------------------------------------------------------*/
  public logout() {
    this.authenticationService.logout();
  }

  /**----------------------------------------------------------------------------
   * onScrollDown
   *-----------------------------------------------------------------------------*/
  public onScrollDown() {
    this.offset = this.offset + SubscriptionPoolsPageComponent.LIMIT;
    this.loadSubscriptionPools(SubscriptionPoolsPageComponent.LIMIT, this.offset, this.searchText, this.searchProperty);
  }

  /**----------------------------------------------------------------------------
   * setSearchProperty
   *-----------------------------------------------------------------------------*/
  public setSearchProperty(searchProperty: string) {
    this.searchProperty = searchProperty;
    this.subscriptionPools = [];

    if (searchProperty === 'poolName') {
      this.nameOfSearch = 'Pool';
    } else {
      this.nameOfSearch = this.searchProperty;
    }
    // user set another searchProperty: retrigger loading of subscriptions
    this.loadSubscriptionPools(SubscriptionPoolsPageComponent.LIMIT, this.offset, this.searchText, this.searchProperty, false);
  }

  /**----------------------------------------------------------------------------
   * refreshAllItems
   *-----------------------------------------------------------------------------*/
  public refreshAllItems() {
    this.loadSubscriptionPools(this.offset + SubscriptionPoolsPageComponent.LIMIT, 0, this.searchText, this.searchProperty, false);
  }

  /**----------------------------------------------------------------------------
   * refreshCallback
   *-----------------------------------------------------------------------------*/
  public refreshCallback() {
    this.refreshAllItems();
    this.timerSubscription = Observable.timer(environment.mainPageRefreshInterval).first().subscribe(() => this.refreshCallback());
  }

  /**
   *
   * @param searchText Save users SearchText for future use
   */
  /**----------------------------------------------------------------------------
   * saveSearchText
   *-----------------------------------------------------------------------------*/
  private saveSearchText(searchText: string, searchProperty: string) {

    if (searchText == null || searchProperty == null) {
      return;
    }

    let lastSearches: LastSearches = JSON.parse(localStorage.getItem(this.username + '-lastsearches-subscription'));
    if (lastSearches == null) {
      lastSearches = new LastSearches();
    }
    const newLastSearch = new LastSearch();
    newLastSearch.setSearchText(searchText);
    newLastSearch.setSearchProperty(searchProperty);
    lastSearches.lastSearchList.push(newLastSearch);

    localStorage.setItem(this.username + '-lastsearches-subscription', JSON.stringify(lastSearches));

    this.lastSearches = lastSearches.lastSearchList.map(
      value => value.searchText
    );
  }


  // /**----------------------------------------------------------------------------
  //  * deleteOperation
  //  *-----------------------------------------------------------------------------*/
  // private deleteOperation() {
  //   const calls = [];
  //   this.selectedSubscriptionIds.forEach(id => {
  //     calls.push(this.defaultService.poolsPoolIdDelete(id));
  //   });
  //
  //   Observable.forkJoin(calls).subscribe(
  //     item => {
  //       this.selectedSubscriptionIds = new Array<number>();
  //       this.refreshAllItems();
  //       this.newSubscriptionForm = null;
  //       this.poolDetails = null;
  //       this.alertService.successModal('Pools deleted successfully');
  //     },
  //     error => {
  //       {
  //         this.selectedSubscriptionIds = new Array<number>();
  //         this.refreshAllItems();
  //         this.errorHandlingService.errorHandling(error);
  //       }
  //     }
  //   );
  // }

  /**----------------------------------------------------------------------------
   * onSubmit
   *-----------------------------------------------------------------------------*/
  public onSubmit(subscription) {
    if (subscription.value.poolName === '' ||
      subscription.value.mnoId === '' ||
      subscription.value.country === '') {
      this.setToDirty();
    } else if (subscription.valid) {
      let poolsat = this.subscriptionPools;
      poolsat = poolsat.sort(function (obj1, obj2) {
        return obj2.poolId - obj1.poolId;
      });
      let newIdPool;
      if (poolsat.length !== 0) {
        newIdPool = poolsat[0].poolId + 1;
      } else {
        newIdPool = 0;
      }
      subscription.value.poolId = newIdPool;

      this.defaultService.poolsPut(subscription.value).subscribe(response => {
          const idNewPool = response;
          this.alertService.successModal('Pool created successfully');
          this.defaultService.poolsPoolIdGet(idNewPool.poolId).subscribe(pool => {
              this.getPoolDetails(pool);
            },
            (error) => {
              this.errorHandlingService.errorHandling(error);
            });
          this.refreshAllItems();
          this.newSubscriptionForm = null;
        },
        (error) => {
          this.refreshAllItems();
          this.errorHandlingService.errorHandling(error);
        });
    }
  }

  /**----------------------------------------------------------------------------
   * getPoolDetails
   *-----------------------------------------------------------------------------*/
  public getPoolDetails(poolDetails: POOLINFO) {
    this.viewMode = true;
    this.newMode = false;
    this.editMode = false;
    if (this.checkAllSubscriptions) {
      this.checkAllSubscriptions.nativeElement.checked = false;
    }
    this.subscriptionsOffset = 0;
    this.selectedPoolOwnerIds = [];
    this.selectedPoolSubscriptionIds = [];
    this.editingPoolIds = [];
    this.newSubscriptionForm = null;
    this.poolDetails = poolDetails;
    this.newSubscriptionForm = this.fb.group({
      poolId: [''],
      poolName: ['', [Validators.required]],
      mnoId: ['', [Validators.required]],
      country: ['', [Validators.required]]
    });
    if (this.tabView === 'tab2') {
      this.showOperationButton = true;
    } else {
      this.showOperationButton = false;
    }
    this.newSubscriptionForm.patchValue(poolDetails);
    this.loadSubscriptionPoolsByPoolId(poolDetails.poolId, SubscriptionPoolsPageComponent.LIMIT, this.subscriptionsOffset);

  }

  /**----------------------------------------------------------------------------
   * loadSubscriptionPoolsByPoolId
   *-----------------------------------------------------------------------------*/
  public loadSubscriptionPoolsByPoolId(poolId: number, limit?: number, offset?: number, concat: boolean = false) {
    this.helpService.poolsPoolIdProfilesGet(poolId, offset, limit).subscribe(response => {

        if (concat) {
          this.mnoSubscriptions = this.mnoSubscriptions.concat(response);
          this.filteredMnoSubscriptions = this.filteredMnoSubscriptions.concat(response);
        } else {
          this.mnoSubscriptions = response;
          this.filteredMnoSubscriptions = response;
        }
      },
      (error) => {
        this.errorHandlingService.errorHandling(error);
      });
  }

  /**----------------------------------------------------------------------------
   * editMsisdn
   *-----------------------------------------------------------------------------*/
  public editMsisdn(mno: any) {
    if (!this.editingPoolIds.includes(mno.veis)) {
      this.editingPoolIds.push(mno.veis);
    }
  }

  /**----------------------------------------------------------------------------
   * addNewPool
   *-----------------------------------------------------------------------------*/
  public addNewPool() {
    this.viewMode = false;
    this.editMode = false;
    this.newMode = true;
    this.newSubscriptionForm = this.fb.group({
      poolId: [''],
      poolName: ['', [Validators.required]],
      mnoId: ['', [Validators.required]],
      country: ['', [Validators.required]]
    });

    this.activeTab = 'home';
    this.tabView = 'tab1';
  }

  /**----------------------------------------------------------------------------
   * cancelNewPool
   *-----------------------------------------------------------------------------*/
  public cancelNewPool() {
    if (this.viewMode === false && this.editMode === false && !this.poolDetails) {
      this.viewMode = false;
      this.newMode = false;
      this.editMode = false;
      this.newSubscriptionForm = null;
    } else {
      this.newSubscriptionForm = null;
      this.editMode = false;
      this.viewMode = true;
      this.newSubscriptionForm = this.fb.group({
        poolId: [''],
        poolName: ['', [Validators.required]],
        mnoId: ['', [Validators.required]],
        country: ['', [Validators.required]]
      });
      this.newSubscriptionForm.patchValue(this.poolDetails);
      this.newMode = false;
    }
  }

  /**----------------------------------------------------------------------------
   * editSubscriptionPool
   *-----------------------------------------------------------------------------*/
  public editSubscriptionPool(poolDetails: any) {
    this.editMode = true;
    this.viewMode = false;
    this.newMode = false;
    this.newSubscriptionForm = this.fb.group({
      poolId: [''],
      poolName: ['', [Validators.required]],
      mnoId: ['', [Validators.required]],
      country: ['', [Validators.required]]
    });

    this.newSubscriptionForm.patchValue(poolDetails);
  }

  /**----------------------------------------------------------------------------
   * updatePool
   *-----------------------------------------------------------------------------*/
  public updatePool({value, valid}: { value: POOLINFO, valid: boolean }) {
    if (this.newSubscriptionForm.value.poolName === '' ||
      this.newSubscriptionForm.value.mnoId === '' ||
      this.newSubscriptionForm.value.country === '') {
      this.setToDirty();
    } else if (this.newSubscriptionForm.valid) {
      this.defaultService.poolsPoolIdPost(this.poolDetails.poolId, this.newSubscriptionForm.value).subscribe(response => {
          this.newSubscriptionForm = null;
          this.subscriptionPools = []; // reset subscriptionslist
          this.offset = 0; // reset offset
          this.loadSubscriptionPools(SubscriptionPoolsPageComponent.LIMIT, this.offset, this.searchText, this.searchProperty, false);
          this.getPoolDetails(value);
          this.alertService.successModal('Subscription updated successfully');
        },
        (error) => {
          this.errorHandlingService.errorHandling(error);
        });
    }
  }

  /**----------------------------------------------------------------------------
   * selectOperation
   *-----------------------------------------------------------------------------*/
  public selectOperation(operation: string) {
    let title = '';
    if (operation === 'move') {
      title = 'MOVE PROFILES';
    }

    const subtitle = '';
    const profiles = this.selectedPoolSubscriptionIds;
    const sourcePool = this.poolDetails;
    const menu = 'CARD';
    const initialState = {
      operation,
      title,
      subtitle,
      profiles,
      sourcePool,
      menu
    };

    this.bsModalRef = this.modalService.show(MoveProfilesModalComponent, {initialState});
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.action.take(1).subscribe((value) => {
        if (value) {
          if (operation === 'move') {
            if (value) {
              this.alertService.successModal('Move completed successfully');
            }
          }
        }
        this.selectedPoolSubscriptionIds = [];
        this.loadSubscriptionPools(SubscriptionPoolsPageComponent.LIMIT, 0, this.searchText, this.searchProperty, false);
        this.getPoolDetails(this.poolDetails);
      },
      (error) => {
        this.errorHandlingService.errorHandling(error);
      });
  }


  /**----------------------------------------------------------------------------
   * auditTrail
   *-----------------------------------------------------------------------------*/
  auditTrail(eid: string) {
    const initialState = {
      eid
    };
    this.bsModalRef = this.modalService.show(SubscriptionPoolMnoAuditComponent, {initialState, class: 'modal-large'});
    this.bsModalRef.content.eid = eid;
  }

  /**----------------------------------------------------------------------------
   * filterMnoSubscriptions
   *-----------------------------------------------------------------------------*/
  public filterMnoSubscriptions(filterBy: string) {
    filterBy = filterBy.toLocaleLowerCase();
    this.helpService.poolsPoolIdProfilesGet(this.poolDetails.poolId, this.offset, SubscriptionPoolsPageComponent.LIMIT, filterBy)
      .subscribe(response => {
          this.mnoSubscriptions = response;
          this.filteredMnoSubscriptions = response;
        },
        (error) => {
          this.errorHandlingService.errorHandling(error);
        });
  }

  /**----------------------------------------------------------------------------
   * get mnoSubscriptionFilterCriteria
   *-----------------------------------------------------------------------------*/
  get mnoSubscriptionFilterCriteria(): string {
    return this._mnoSubscriptionFilterCriteria;
  }

  /**----------------------------------------------------------------------------
   * set mnoSubscriptionFilterCriteria
   *-----------------------------------------------------------------------------*/
  set mnoSubscriptionFilterCriteria(value: string) {
    this._mnoSubscriptionFilterCriteria = value;
    this.mnoSubscriptionFilterCriteria ? this.filterMnoSubscriptions(this._mnoSubscriptionFilterCriteria) : this.mnoSubscriptions;
  }


  /**----------------------------------------------------------------------------
   * onSubscriptionScrollDown
   *-----------------------------------------------------------------------------*/
  public onSubscriptionScrollDown() {
    this.subscriptionsOffset = this.subscriptionsOffset + SubscriptionPoolsPageComponent.LIMIT;
    this.loadSubscriptionPoolsByPoolId(this.poolDetails.poolId, SubscriptionPoolsPageComponent.LIMIT, this.subscriptionsOffset, true);
  }

  /**----------------------------------------------------------------------------
   * setToDirty
   *-----------------------------------------------------------------------------*/
  setToDirty() {
    this.newSubscriptionForm.controls.poolName.markAsDirty();
    this.newSubscriptionForm.controls.mnoId.markAsDirty();
    this.newSubscriptionForm.controls.country.markAsDirty();
  }

  /**----------------------------------------------------------------------------
   * changeTabToHome
   *-----------------------------------------------------------------------------*/
  public changeTabToHome() {
    this.activeTab = 'home';
    this.tabView = 'tab1';
  }

  /**----------------------------------------------------------------------------
   * changeTabToContentBrowser
   *-----------------------------------------------------------------------------*/
  public changeTabToContentBrowser() {
    this.activeTab = 'menu1';
    this.tabView = 'tab2';
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/subscription-pools-page/subscription-pools-page.component.ts